import {pluralize} from "@pg-mono/string-utils";

const THOUSANDS_SEPARATOR = " ";
const transactionsPluralize = pluralize(["transakcja", "transakcje", "transakcji"]);

const groupThousands = (value: number): string => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS_SEPARATOR);

/**
 * "1 transakcja", "22 transakcje", "142 transakcje", "1 245 transakcji"; a sum over an incomplete set of rows is a
 * lower bound and reads "120+ transakcji".
 */
export const formatTransactionsCount = (count: number, isLowerBound = false): string => {
    const value = Math.max(0, Math.round(count));

    return isLowerBound ? `${groupThousands(value)}+ transakcji` : `${groupThousands(value)} ${transactionsPluralize(value)}`;
};

/**
 * Genitive form for "na podstawie "/"na bazie " phrases - unlike formatTransactionsCount, always "transakcji"
 * regardless of count (singular and plural genitive are the same word for this noun).
 */
export const formatTransactionsCountGenitive = (count: number, isLowerBound = false): string => {
    const value = Math.max(0, Math.round(count));

    return isLowerBound ? `${groupThousands(value)}+ transakcji` : `${groupThousands(value)} transakcji`;
};
import {pluralize} from "@pg-mono/string-utils";

const THOUSANDS_SEPARATOR = " ";
const transactionsPluralize = pluralize(["transakcja", "transakcje", "transakcji"]);

const groupThousands = (value: number): string => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS_SEPARATOR);

/**
 * "1 transakcja", "22 transakcje", "142 transakcje", "1 245 transakcji"; a sum over an incomplete set of rows is a
 * lower bound and reads "120+ transakcji".
 */
export const formatTransactionsCount = (count: number, isLowerBound = false): string => {
    const value = Math.max(0, Math.round(count));

    return isLowerBound ? `${groupThousands(value)}+ transakcji` : `${groupThousands(value)} ${transactionsPluralize(value)}`;
};

/**
 * Genitive form for "na podstawie "/"na bazie " phrases - unlike formatTransactionsCount, always "transakcji"
 * regardless of count (singular and plural genitive are the same word for this noun).
 */
export const formatTransactionsCountGenitive = (count: number, isLowerBound = false): string => {
    const value = Math.max(0, Math.round(count));

    return isLowerBound ? `${groupThousands(value)}+ transakcji` : `${groupThousands(value)} transakcji`;
};
